






















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import AsesmenAwalBayiBaruLahirSvc from "@/services/AsesmenAwalBayiBaruLahir";
import CardAsesmenBayiBaruLahir from "./CardAsesmenBayiBaruLahir.vue";
import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

@Component({
  components: { CardAsesmenBayiBaruLahir },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PanelBblKebidanan extends Vue {
  @Prop() readonly register!: number; // register IBU
  @Prop() readonly rm!: number | string; // RM IBU
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  loading = false;
  babies: any[] = [];

  // bayi yang sedang dibuka {register, rm, nama}
  activeBaby: { register: number; rm: number | string; nama: string } | null = null;

  // dialog picker
  pickerDialog = false;
  searchTerm = "";
  searching = false;
  searchedOnce = false;
  searchResults: any[] = [];
  selectedPasien: any = null;
  loadingRegister = false;
  babyRegisters: any[] = [];
  selectedRegister: number | null = null;

  mounted() {
    this.fetchBabies();
  }

  async fetchBabies() {
    if (!this.register) return;
    this.loading = true;
    try {
      const resp = await AsesmenAwalBayiBaruLahirSvc.getByMotherRegister(this.register);
      this.babies = resp.data?.data || [];
    } finally {
      this.loading = false;
    }
  }

  openBaby(baby: any) {
    this.activeBaby = {
      register: baby.register_id,
      rm: baby.pasien_rm,
      nama: (baby.pasien && baby.pasien.nama) || "Bayi RM " + baby.pasien_rm
    };
  }

  closeBaby() {
    this.activeBaby = null;
    this.fetchBabies();
  }

  onChildChanged() {
    this.fetchBabies();
  }

  onChildRemoved() {
    this.activeBaby = null;
    this.fetchBabies();
  }

  // ----- Picker -----
  openPicker() {
    this.pickerDialog = true;
    this.searchTerm = "";
    this.searchResults = [];
    this.searchedOnce = false;
    this.selectedPasien = null;
    this.babyRegisters = [];
    this.selectedRegister = null;
  }

  async searchPasien() {
    const term = (this.searchTerm || "").trim();
    if (!term) return;
    this.searching = true;
    this.searchedOnce = true;
    this.selectedPasien = null;
    this.babyRegisters = [];
    this.selectedRegister = null;
    try {
      const resp = await http.getData(`/pasien?term=${encodeURIComponent(term)}`);
      const body = resp.data;
      this.searchResults = Array.isArray(body) ? body : body?.data || [];
    } catch (err) {
      ErrorAlert.showErrorAlert(err);
    } finally {
      this.searching = false;
    }
  }

  async selectPasien(p: any) {
    this.selectedPasien = p;
    this.selectedRegister = null;
    this.babyRegisters = [];
    this.loadingRegister = true;
    try {
      const resp = await http.getData(`/pasien/${p.rm}/register`);
      const body = resp.data;
      this.babyRegisters = Array.isArray(body) ? body : body?.data || [];
    } catch (err) {
      ErrorAlert.showErrorAlert(err);
    } finally {
      this.loadingRegister = false;
    }
  }

  regUnitName(reg: any): string {
    if (!reg) return "-";
    if (reg.unit && typeof reg.unit === "object") return reg.unit.nama || reg.unit.id || "-";
    return reg.unit || "-";
  }

  confirmPick() {
    if (!this.selectedRegister || !this.selectedPasien) return;
    this.activeBaby = {
      register: this.selectedRegister,
      rm: this.selectedPasien.rm,
      nama: this.selectedPasien.nama
    };
    this.pickerDialog = false;
  }
}
